import React, { useState, useEffect } from 'react'
import { Row, Col, Form, Card, Button, Divider, Checkbox, message, Modal } from 'antd'

import { connect } from 'react-redux'
import { resetForm } from "../../../../services/helper";
import { EyeIcon, ModalCloseIco, TabsInfoIco, TabsInfoIco2 } from "../../../../../modules/CustomIcons";
import PasswordField from "components/Password";
import CustomTooltip from "components/Tooltip";
import { changePasswordVerify, updatePassword } from "../../../../services/Auth/ChangePassword";
import SuccessOrErrorModal from "components/SuccessOrErrorModal";
import OtpInput from "react-otp-input";
import Timer from "components/Timer";
import { useActions } from "hooks/useActions";
import { useHistory } from "react-router-dom";
import { secureLocalStorageGet } from '../../../../helpers';
import { useTranslation } from 'react-i18next';
import messageList from "assets/locales/translate.json";
import {getMessageLists} from "store/actions/home";
import useResponsiveWidth from 'hooks/useResponsiveWidth';
import forge from "node-forge";
import { API_URL } from '../../../../services/config/index'
import { v4 as uuidv4 } from "uuid";
import axios from 'axios';
const errorMessagesReset = {
    1: '',
    2: ''
}

const modalReset = {
    modalTitle: '',
    modalText: '',
    modalType: '',
    modalWidth: 580,
    modalClass: ''
}

const ChangePassword: React.FC<any> = ({ leftMenuStatus,messageList }) => {
    const {t} = useTranslation()
    const [form] = Form.useForm();
    const responsiveWidth = useResponsiveWidth()
    // const formRef = createRef();
    const { changeStatusHandler } = useActions()

    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);

    const [otpCodeModalVisible, setOtpCodeModalVisible] = useState(false)
    const [otpCode, setOtpCode] = useState<number[]>([])
    const [otpNumberCount, setOtpNumberCount] = useState<number>(6)
    const [phoneNumber, setPhoneNumber] = useState<string>()
    const [otpCodeHasError, setOtpCodeHasError] = useState<boolean>(false)
    const [modalData, setModalData] = useState(modalReset)
    const [isChannel, setIsChannel] = useState(null);
    const [buttonClicked, setButtonClicked] = useState(0)
    const [textArray, setTextArray] = useState([])
    const [errorMessage, setErrorMessage] = useState(errorMessagesReset);
    const history = useHistory();
    const [smsClicked, setClicked] = useState(false)


    const language = localStorage.getItem("i18nextLng")
    useEffect(() => {
        const fetchessageData = async () => {
            let lang_text = messageList?.result!== undefined ? (language=="az" ? messageList.result.find(text=> text.messageKey === 'INFO.NEW_PASS')?.textAZE :  language=="ru" ?
                messageList.result.find(text=> text.messageKey === 'INFO.NEW_PASS')?.textRU : language=="en" ?  messageList.result.find(text=> text.messageKey === 'INFO.NEW_PASS')?.textENG:""):"" ;
            const array = lang_text !== null  && lang_text !== undefined ? lang_text.split("|") : [];
            setTextArray(array);
        };



        fetchessageData();

    }, [messageList,language])
    const ToolTipDropDown = () => {
        return(
            textArray.map((line:any,index:number) => {
                return (
                    line.startsWith('http') ?
                        `<a href=${line} key=${index} > ${line} </a>`
                        :
                        `<p key=${index}> ${line} </p>`
                )

            }).join(''))
    }
    const checkPassInputs = (args: any) => {
        const oldPassword = args.oldPassword;
        const newPassword = args.newPassword;
        const newPasswordRepeat = args.newPasswordRepeat;


        const strongRegex = new RegExp(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()+=-\?;,./{}|\":<>\[\]\\\' ~_]).{8,}/);

        setErrorMessage(old_data => {
            return errorMessagesReset
        })
        setShowErrorMessage(false)

        setShowSuccessMessage(false)

        if (newPassword.length < 8 || newPasswordRepeat.length < 8) {

            if (newPassword.length < 8) {
                setErrorMessage(old_data => {
                    return { ...old_data, 1: t("settings.password8Symbol") }
                })
            }

            if (newPasswordRepeat.length < 8) {
                setErrorMessage(old_data => {
                    return { ...old_data, 2: t("settings.password8Symbol") }
                })
            }

            setShowErrorMessage(true)

        } else if (newPassword.length > 20 || newPasswordRepeat.length > 20) {

            if (newPassword.length > 20) {
                setErrorMessage(old_data => {
                    return { ...old_data, 1: t("login.password20Symbol") }
                })
            }

            if (newPasswordRepeat.length > 20) {
                setErrorMessage(old_data => {
                    return { ...old_data, 2: t("login.password20Symbol") }
                })
            }


            setShowErrorMessage(true)

        } else if (!strongRegex.test(newPassword) || !strongRegex.test(newPasswordRepeat)) {

            if (!strongRegex.test(newPassword)) {
                setErrorMessage(old_data => {
                    return { ...old_data, 1: t("settings.passwordSpecialSymbols") }
                })
            }

            if (!strongRegex.test(newPasswordRepeat)) {
                setErrorMessage(old_data => {
                    return { ...old_data, 2: t("settings.passwordSpecialSymbols") }
                })
            }

            setShowErrorMessage(true)

        } else if (newPassword !== newPasswordRepeat) {

            setErrorMessage(old_data => {
                return { ...old_data, 2: t("settings.passwordNotSame") }
            })


            setShowErrorMessage(true)

        } else {
            //update password
            changePassword();
            setButtonClicked(buttonClicked + 1);
        }

    }

    const showOtpCodeModal = () => {
        setOtpCodeModalVisible(true)
        setOtpCode((old_data) => [])
        setOtpCodeHasError((old_data) => false)
    }

    const checkOTPCode = () => {
        if (otpCode.length == 5 || otpCode.length == 6) {

            let request_data = {
                userName: secureLocalStorageGet('username'),
                verfication: otpCode
            }


            changePasswordVerify(request_data).then((res) => {

                if (res.status === 'ERROR') {
                    setOtpCodeHasError((old_data) => true)

                    setModalData(old_data => {
                        return {
                            modalTitle: t("common.error"),
                            modalText: t("settings.currentPasswordWrong"),
                            modalType: 'error',
                        }
                    })

                } else {

                    setModalData(old_data => {
                        return {
                            modalTitle: t("notification.attention"),
                            modalText: t("settings.passwordChangedSuccess"),
                            modalType: 'success',
                            modalWidth: 396,
                            modalClass: "changePswModal"
                        }
                    })

                    changeStatusHandler()
                    setOtpCodeHasError((old_data) => false)
                    setOtpCodeModalVisible(false)
                    setShowSuccessMessage(true)
                }
            }).catch((err) => {
                setOtpCodeHasError((old_data) => true)

                setModalData(old_data => {
                    return {
                        modalTitle: t("common.error"),
                        modalText: t("settings.currentPasswordWrong"),
                        modalType: 'error',
                    }
                })

            })
        }
    }

    const hideOtpCodeModal = () => {
        setOtpCodeModalVisible(false)
    }

    const handleValue = (value: any) => {
        setOtpCode(value)
    }

    const sendSmsCode = () => {
        setClicked(false)
        changePassword()
    }

    useEffect(
        () => {
            if (!smsClicked) {
                let timer1 = setInterval(() => setClicked(true), 20 * 1000);
                return () => {
                    clearInterval(timer1);
                }
            }
        },
        [buttonClicked, smsClicked]
    );
    const spkiBase64ToPem = (spkiB64: string) => {
            const clean = spkiB64.replace(/\s+/g, "");
            const lines = clean.match(/.{1,64}/g)?.join("\n") ?? clean;
            return `-----BEGIN PUBLIC KEY-----\n${lines}\n-----END PUBLIC KEY-----`;
          };
          
          const encryptPasswordDevglan = (password: string, publicKeySpkiBase64: string) => {
            const pem = spkiBase64ToPem(publicKeySpkiBase64);
            const pubKey = forge.pki.publicKeyFromPem(pem);
          
            const encryptedBytes = pubKey.encrypt(password, "RSA-OAEP", {
              md: forge.md.sha256.create(),
              mgf1: {
                md: forge.md.sha1.create(),
              },
            });
          
            return forge.util.encode64(encryptedBytes);
          };
    const changePassword = async () => {
        const oldPassword = form.getFieldValue("oldPassword");
        const newPassword = form.getFieldValue("newPassword");
        const newPasswordRepeat = form.getFieldValue("newPasswordRepeat");

        const encryptPasswordWithFreshNonceAndKey = async (password: string) => {
            const pkResp = await axios.get(`${API_URL}auth/get-ldap-public-key`);
            const publicKeyB64 = pkResp?.data?.publicKey;

            if (!publicKeyB64) throw new Error("publicKey gəlmədi");

            const timestamp = pkResp?.data?.serverDate.toString() 
            //  Math.floor(Date.now() / 1000).toString();
            const nonce = uuidv4();
            const passwordPayload = `${timestamp}${nonce}${password}`;

            return encryptPasswordDevglan(passwordPayload, publicKeyB64);
        };

        const passwordEncOld = await encryptPasswordWithFreshNonceAndKey(oldPassword);

        let passwordEncNew: any;
        let passwordEncNewRepeat: any;

        if (newPassword === newPasswordRepeat) {
            passwordEncNew = await encryptPasswordWithFreshNonceAndKey(newPassword);
            passwordEncNewRepeat = await encryptPasswordWithFreshNonceAndKey(newPasswordRepeat);
        }

        updatePassword({
            userName: secureLocalStorageGet("username"),
            oldPassword: passwordEncOld,
            newPassword: passwordEncNew,
            newPasswordRepeat: passwordEncNewRepeat,
        }).then((res) => {
            let channel = secureLocalStorageGet("channel");
            setIsChannel(channel);

            if (channel === "TOTP" || channel === "OTP") {
            let phone_number: any = secureLocalStorageGet("phoneNumber");
            let last_4_number = phone_number.slice(-4);
            let make_phone_number =
                last_4_number[0] +
                last_4_number[1] +
                "-" +
                last_4_number.slice(-2);

            setOtpNumberCount((old_number) => (channel === "TOTP" ? 6 : 5));
            setPhoneNumber((old_data) => make_phone_number);
            showOtpCodeModal();

            setClicked(false);
            }
        });
    };

    const closeModal = () => {
        setShowSuccessMessage(old_data => false);
        setModalData(old_data => modalReset);
        resetForm(form);
    }


    return (
        <>
            <div className={'settings_sides settings_right_side'} >

                <Row justify='start' className="own-account__form full settings_reset_password_form">
                    <Form
                        labelCol={{ flex: responsiveWidth < 575 ? '100px' : '170px' }}
                        wrapperCol={{ flex: 1 }}
                        className='full'
                        onSubmit={(e: any) => e.preventDefault(e)}
                        onFinish={checkPassInputs}
                        id={'form'}
                        form={form}
                        autoComplete="off"
                    >
                        <div className='flex direction_column' >
                            <PasswordField
                                labelItem={t("settings.currentPassword")}
                                placeholder=""
                                name={'oldPassword'}
                                required={true}
                                form={form}
                                className={'pass_no_padding settings_pass_input'}
                            />

                            <PasswordField
                                labelItem={t("settings.newPassword")}
                                placeholder=""
                                name={'newPassword'}
                                required={true}
                                form={form}
                                suffix={<CustomTooltip
                                    title={ToolTipDropDown()}
                                                       className={'password_tooltip'} >
                                    <Button type={'ghost'} style={{left:85}} className={'transparent'} icon={<TabsInfoIco2 />} />
                                </CustomTooltip>}
                                className={'pass_no_padding settings_pass_input'}
                                maxLength={20}
                                message={showErrorMessage && errorMessage["1"]}
                                showMessage={showErrorMessage}
                            />

                            <PasswordField
                                labelItem={t("settings.repeatPassword")}
                                placeholder=""
                                name={'newPasswordRepeat'}
                                required={true}
                                form={form}
                                className={'pass_no_padding settings_pass_input'}
                                maxLength={20}
                                message={showErrorMessage && errorMessage["2"]}
                                showMessage={showErrorMessage}
                            />

                            <div className='flex button_row justify_end setting_reset_pass_btns' >
                                <Button
                                    size={'large'}
                                    className="light-button refresh_btn btn flex align_center justify_center"
                                    onClick={(e) => { history.push('/'); }}
                                >
                                    {t("settings.changepasscancel")}
                                </Button>

                                <Button
                                    size={'large'}
                                    htmlType="submit"
                                    className="blue-button next_btn btn flex align_center justify_center"
                                >
                                    {t("salary.refresh")}
                                </Button>
                            </div>

                        </div>
                    </Form>
                </Row>

            </div>

            {otpCodeModalVisible && (
                <Modal
                    title={isChannel === "TOTP" ? `Google kod ilə təsdiqlə` : t("settings.confirmBySms")}
                    closeIcon={<ModalCloseIco />}
                    centered
                    visible={otpCodeModalVisible}
                    onOk={hideOtpCodeModal}
                    onCancel={hideOtpCodeModal}
                    width={422}
                    className={`manage_faster_menus swift_modal form_next_modal otp_code_verify_modal`}
                    keyboard={false}
                    focusTriggerAfterClose={false}
                    footer={false}
                >
                    <div
                        className={
                            'flex direction_column align_center otp_code_verify_modal_body'
                        }
                    >
                        {
                            isChannel === "TOTP" ?
                                <p>
                                    {t("settings.enterGeneratedCode")}
                                </p> :
                                <p>
                                    {t("settings.otpcode1")}{phoneNumber} {t("settings.otpcode2")} <br />
                                    {t("settings.otpcode3")}
                                </p>
                        }


                        <Form
                            form={form}
                            onSubmit={(e: any) => e.preventDefault()}
                            onFinish={checkOTPCode}
                            shouldAutoFocus={true}
                            autoComplete="off"
                            className={
                                otpCodeHasError
                                    ? 'message-input-form flex direction_column justify_center has_error'
                                    : 'flex direction_column justify_center message-input-form checkOTPChangePswForm'
                            }
                        >
                            <OtpInput
                                value={otpCode}
                                onChange={handleValue}
                                numInputs={otpNumberCount}
                                inputStyle="otpInput"
                                isInputNum={true}
                                shouldAutoFocus={true}
                                className="message-input-form__input"
                            />

                            {otpCodeHasError && (
                                <span className={'verify_code_error flex full justify_center'}>
                                    {t("transfers.wrongCodeEntered")}
                                </span>
                            )}

                            <div className={'full flex direction_column'}>
                                <ul
                                    className="message-form__details full"
                                    style={{ marginTop: otpCodeHasError ? 16 : 21 }}
                                >
                                    <li className="message-form__time">
                                        {otpCode ? (
                                            <Timer timerEnd={resetForm} buttonClicked = {buttonClicked} />
                                        ) : (
                                            <span>00:00</span>
                                        )}
                                    </li>
                                    {
                                        isChannel === "TOTP" ? <></> :
                                            <li>
                                                <a onClick={sendSmsCode} className={(smsClicked) ? 'active reSend' : 'disabled reSend'}>{t("settings.detailsData")}</a>

                                            </li>
                                    }
                                </ul>

                                {/* <Button
                                    type={'ghost'}
                                    className={(smsClicked) ? 'transparent resend_verify_code_btn active' : 'disabled transparent resend_verify_code_btn'}
                                // className={'transparent resend_verify_code_btn'}
                                >
                                    SMS kodu yenidən göndər
                                </Button> */}

                                <div className="login-form__buttons flex justify_center">
                                    <Button
                                        size={'large'}
                                        className="prev ant-btn ant-btn-lg light-button refresh_btn btn flex align_center justify_center"
                                        onClick={hideOtpCodeModal}
                                    >
                                        {t("transfers.back")}
                                    </Button>
                                    <Button
                                        size={'large'}
                                        className="next ant-btn ant-btn-lg blue-button next_btn btn flex align_center justify_center"
                                        htmlType="submit"
                                    >
                                        {t("login.confirm")}
                                    </Button>
                                </div>
                            </div>
                        </Form>
                    </div>
                </Modal>
            )}

            <SuccessOrErrorModal
                visible={showSuccessMessage}
                modalTitle={modalData.modalTitle}
                modalText={modalData.modalText}
                modalType={modalData.modalType}
                width={modalData.modalWidth}
                className={modalData.modalClass}
                onCancel={closeModal}
            />
        </>
    )
}

const mapDispatchToProps = {
     getMessageLists
}
const mapStateToProps = (state: any) => ({
    leftMenuStatus: state.home.leftMenuStatus,
    messageList: state.home.messageList,
})
export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword)
